import poptoken_builder from "./poptoken-builder-node";

const {VITE_PRIVATE_KEY} = typeof import.meta !== 'undefined' ? import.meta.env : process.env;

export const createPopToken = (method, url, authorization, body) => {
    const ehtsKeyValueMap = new Map();
    const pathname = new URL(url).pathname;
    // authorization && ehtsKeyValueMap.set('Authorization', authorization);
    ehtsKeyValueMap.set('uri', pathname);
    ehtsKeyValueMap.set('http-method', method.toUpperCase());
    // if (!(method === 'get' || JSON.stringify(body) === '{}')) {
    //   ehtsKeyValueMap.set('body', method === 'get' ? '' : JSON.stringify(body));
    // }
  
    const privateKeyPemStr = '' + VITE_PRIVATE_KEY;
    try {
      const popToken = poptoken_builder.buildPopToken(
        ehtsKeyValueMap,
        privateKeyPemStr
      );
      return popToken;
    } catch (error) {
      console.log('Error:', error);
    }
  };